import { Dispatch, SetStateAction, useContext, useEffect, useMemo } from 'react'

import { compareStrings, ErrorMessages } from '@lib/helpers'
import { InstitutionContext } from '@lib/institution-context'
import { StringsContext } from '@lib/strings-context'

import InputSearchDropdown from '@components/input-search-dropdown'
import { SearchDropdownOption } from '@lib/dom'

interface InstitutionFieldProps {
  errorMessages: ErrorMessages
  setErrorMessages: Dispatch<SetStateAction<ErrorMessages>>
  className?: string
}

const InstitutionField = ({
  errorMessages,
  setErrorMessages,
  className,
}: InstitutionFieldProps) => {
  const { institutions, institutionId, setInstitutionId } =
    useContext(InstitutionContext)
  const strings = useContext(StringsContext)

  const institutionOptions = useMemo(() => {
    const institutionOptions = institutions
      .filter((institution) => institution.isPublic)
      .map((institution) => {
        const searchDropdownOption: SearchDropdownOption = {
          value: institution.id,
          label: institution.name,
        }

        return searchDropdownOption
      })

    return institutionOptions.sort((institution1, institution2) => {
      return compareStrings(institution1.label, institution2.label)
    })
  }, [institutions])

  // Remove error on change
  useEffect(() => {
    if (institutionId) {
      setErrorMessages((messages) => ({
        ...messages,
        institutionId: '',
      }))
    }
  }, [setErrorMessages, institutionId])

  return (
    <InputSearchDropdown
      className={className}
      id="institution-dropdown"
      label={strings.cartSchoolInputLabel}
      placeholder={strings.cartSchoolInputPlaceholder}
      value={institutionId}
      errorMessage={errorMessages.institutionId}
      options={institutionOptions}
      onChange={(value) => {
        setInstitutionId(value)
      }}
    />
  )
}

export default InstitutionField
